import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables');
}

// Create Supabase client with proper configuration
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'supabase.auth.token',
    storage: window.localStorage
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  global: {
    headers: {
      'X-Client-Info': 'admin-panel'
    },
    fetch: (...args) => {
      // Add custom error handling for fetch operations
      return fetch(...args).then(response => {
        if (!response.ok) {
          // Log the error but don't throw yet - let the caller handle it
          console.warn(`Supabase request failed: ${response.status} ${response.statusText}`);
        }
        return response;
      }).catch(error => {
        // Log network errors
        console.error('Supabase network error:', error);
        throw error;
      });
    }
  }
});

// Enable realtime subscriptions for specific tables
supabase.channel('custom-all-channel')
  .on(
    'postgres_changes',
    {
      event: '*',
      schema: 'public',
      table: 'mensajes'
    },
    (payload) => {
      console.log('Change received!', payload);
    }
  )
  .subscribe();